import RecentlyViewed from "./recentlyViewed";
export default RecentlyViewed;
